import React, { useState } from "react";
import Button from "./Button";
import { useVerificationTimer } from "../hooks/useVerificationTimer";
import { useToasts } from "../hooks/useToasts";

const VerificationButton = ({ userId, onSend, className = "button-btn-light-blue" }) => {
  const { timeLeft, canSend, formatTime, startCooldown } = useVerificationTimer(userId);
  const { addToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    // Prevent multiple clicks
    if (isLoading) return;
    
    if (!canSend) {
      addToast(`Please wait ${formatTime(timeLeft)} before sending another verification email`, "error-warning");
      return;
    }
    
    setIsLoading(true);
    try {
      await onSend();
      startCooldown(180000); // 3 minutes
    } catch (error) {
      console.error('Send verification error:', error);
      // Don't start cooldown on error
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      className={className}
      onClick={handleClick}
      disabled={isLoading}
      type="button"
    >
      {isLoading ? 'Sending...' : canSend ? 'Send Verification' : `Send Verification - Wait ${formatTime(timeLeft)}`}
    </Button>
  );
};

export default VerificationButton;